<template>
  <section :class="[$style.ctn, { [$style.printed]: printed, [$style.open]: open }]">
    <div :class="$style.head">
      <button type="button" :class="[$style.title, com.title]" @click="toggle">
        <h2>{{ title }}</h2>
      </button>
      <CheckboxComponent v-model="printed" :class="$style.checkbox" />
      <button :class="$style.arrowButton" title="Toggle section" type="button" @click="toggle">
        <SvgIcon width="18" height="18" src="icon-sprite.svg#arrow" />
      </button>
    </div>
    <AutoHeight :wrapper-class="$style.content" :open="open">
      <slot />
    </AutoHeight>
  </section>
</template>

<script>
import { defineComponent } from 'vue';

import Ancor from './Ancor.vue';
import AutoHeight from './AutoHeight.vue';
import CheckboxComponent from './CheckboxComponent.vue';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: {
    CheckboxComponent,
    AutoHeight,
    Ancor,
    SvgIcon,
  },
  props: {
    title: { type: String, required: true },
  },
  data: () => ({
    printed: true,
    open: true,
  }),
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
});
</script>

<style module lang="scss">
.head {
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  position: relative;
  padding: 1px 0;

  &::after {
    content: '';
    width: 100%;
    position: absolute;
    display: block;
    height: 2px;
    top: 100%;
    background-color: #3f4757;
    border-radius: 1px;
  }
}
.title {
  margin-right: 30px;
  flex: 1 1 auto;
  text-align: start;
}
.arrowButton {
  display: block;
  width: 18px;
  height: 18px;
  margin-right: 1px;

  @media print {
    display: none;
  }
}
.checkbox {
  margin-right: 31px;

  @media screen and (max-width: 700px) {
    display: none;
  }

  @media print {
    display: none;
  }
}
.ctn {
  &:not(.printed) {
    @media not print {
      .title,
      .content {
        opacity: 0.3;
      }
      .head {
        &::after {
          background-color: rgba(63, 71, 87, 0.3);
        }
      }
    }

    @media print {
      display: none;
    }
  }

  &.open {
    .arrowButton {
      transform: scaleY(-1);
    }
  }

  &.printed {
    .content {
      @media print {
        display: block !important;
      }
    }
  }
}
</style>
<style lang="scss" src="./common.module.scss" module="com"></style>
